export default {
  tenants: [],

  signatories: [],

  tenantsSchedule: [],

  tenantsSettings: {},

  photoUpload: [],

  individtenants: [],
};
